module.exports = __webpack_public_path__ + "static/media/clock_icon.4869a97b.png";